var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionPlan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56383 1C3.32645 1 1.5127 2.79086 1.5127 5V19C1.5127 21.2091 3.32645 23 5.56383 23H19.7428C21.9802 23 23.7939 21.2091 23.7939 19V5C23.7939 2.79086 21.9802 1 19.7428 1H5.56383ZM19.7428 3H5.56383C4.44514 3 3.53826 3.89543 3.53826 5V19C3.53826 20.1046 4.44514 21 5.56383 21H19.7428C20.8615 21 21.7684 20.1046 21.7684 19V5C21.7684 3.89543 20.8615 3 19.7428 3ZM6.57662 12.071L10.8735 16.3137L18.035 9.24262L16.6027 7.8284L10.8735 13.4853L8.00891 10.6568L6.57662 12.071Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPlan);
export default __webpack_public_path__ + "static/media/action_plan.ad5320d999e3cc2b04064a6ab87a3adf.svg";
export { ForwardRef as ReactComponent };